import { ChevronDown } from "lucide-react";
import { C } from "../../theme/tokens";
import { useCollapsedSection } from "../../hooks/useCollapsedSections";

/* Collapsible profile section — wraps any block with a clickable
   header that toggles open/closed.  The open/closed state is
   persisted to localStorage via useCollapsedSection so it survives
   reloads.  Animation uses the 0fr↔1fr grid-template-rows trick
   (same approach as AccountSecurityCard's Expandable). */
export function CollapsibleSection({ title, storageKey, defaultOpen = true, children }) {
  const [open, toggle] = useCollapsedSection(storageKey, defaultOpen);

  return (
    <div>
      <button
        type="button"
        onClick={toggle}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          padding: 0,
          marginBottom: open ? 10 : 0,
          border: "none",
          background: "transparent",
          cursor: "pointer",
          transition: "margin-bottom .22s ease",
        }}
      >
        <span
          style={{
            fontSize: 12,
            color: C.mutedB,
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}
        >
          {title}
        </span>
        <ChevronDown
          size={14}
          color={C.mutedB}
          style={{
            transform: open ? "rotate(0deg)" : "rotate(-90deg)",
            transition: "transform .22s ease",
            flexShrink: 0,
          }}
        />
      </button>

      <div
        style={{
          display: "grid",
          gridTemplateRows: open ? "1fr" : "0fr",
          transition: "grid-template-rows .22s ease",
        }}
      >
        <div style={{ overflow: "hidden" }}>{children}</div>
      </div>
    </div>
  );
}
